import React from 'react';
import PropTypes from 'prop-types';
import Panel from '../../../../Components/Panel';
import { SERVICESTATE_CLOSED } from '../../../../Library/States/ServiceStates';

/**
 * ClosedHint()
 * @param props
 * @returns {*}
 * @constructor
 */
export default function ClosedHint(props) {
  const { service } = props;

  const renderComment = () => {
    if (service.closedComment) {
      return <i>{service.closedComment}</i>;
    }
    return <i>Keine Bemerkung hinterlegt!</i>;
  };

  if (service.state === SERVICESTATE_CLOSED) {
    return (
      <Panel marginBottom={25}>
        <div className="text-center">
          <div>
            <strong>
              Dieser Serviceauftrag wurde manuell auf "Erledigt" gestellt. Es wurde kein Bericht erstellt!
            </strong>
          </div>
          <div>Es wurde folgende Bemerkung zur manuellen Erledigung hinterlegt:</div>
          <div style={{ color: '#000' }}>
            {renderComment()}
          </div>
        </div>
      </Panel>
    );
  }
  return null;
}

ClosedHint.propTypes = {
  service: PropTypes.instanceOf(Object).isRequired,
};
